'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Trash = function Trash(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 390 445' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'g',
        { fill: 'currentColor' },
        _react2.default.createElement('path', { d: 'M181 184h28v193h-28zM124 184h28v193h-28zM238 184h29v193h-29z' }),
        _react2.default.createElement('path', { d: 'M267 65V9H124v56H9v29h29v343h314V94h29V65H267zM152 36h86v30h-86V36zm172 373H67V94h257v315z' })
      )
    )
  );
};
/*eslint-enable */

exports.default = Trash;
//# sourceMappingURL=Trash.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Trash.js